import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import MuiDialog from '../../../UI/MuiDialog/MuiDialog';
import DecimalInput from '../../../UI/FormControls/DecimalInput';
import OInput from '../../../UI/FormControls/OInput';
import { formatDateBody } from '../../../../../utils/FormatDate';

const EditOverallProgressDialog = ({
  open,
  handleClose,
  handleConfirm,
  initialProgres,
  initialDatum,
  loading,
}) => {
  const { t } = useTranslation();
  const [formValues, setFormValues] = useState({
    ukupanProgres: '',
    predvidjeniDatumIzrada: '',
  });

  useEffect(() => {
    if (open) {
      setFormValues({
        ukupanProgres:
          initialProgres !== undefined && initialProgres !== null
            ? String(initialProgres)
            : '',
        predvidjeniDatumIzrada: initialDatum
          ? formatDateBody(initialDatum)
          : '',
      });
    }
  }, [open, initialProgres, initialDatum]);

  const handleProgresChange = (values) => {
    setFormValues((curr) => ({
      ...curr,
      ukupanProgres: values.value,
    }));
  };

  const handleChange = (e) => {
    setFormValues((curr) => ({
      ...curr,
      [e.target.name]: e.target.value,
    }));
  };

  const onConfirm = () => {
    handleConfirm({
      ukupanProgres:
        formValues.ukupanProgres === ''
          ? 0
          : parseFloat(formValues.ukupanProgres),
      predvidjeniDatumIzrada: formValues.predvidjeniDatumIzrada || null,
    });
  };

  return (
    <MuiDialog
      open={open}
      handleClose={handleClose}
      handleConfirm={onConfirm}
      title={t('projectProgress.editOverallProgressTitle')}
      maxWidth="xs"
      loading={loading}
      content={
        <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
          <DecimalInput
            label={t('projectProgress.overallProgress')}
            name="ukupanProgres"
            value={formValues.ukupanProgres}
            handleChange={handleProgresChange}
            decimalScale={2}
            style={{ width: '100%' }}
          />
          <OInput
            label={t('projectProgress.estimatedCompletion')}
            name="predvidjeniDatumIzrada"
            type="date"
            value={formValues.predvidjeniDatumIzrada}
            handleChange={handleChange}
            style={{ width: '100%' }}
          />
        </div>
      }
    />
  );
};

export default EditOverallProgressDialog;
